import React from "react";

export default function CommunityGuidelines() {
  const card = {
    maxWidth: 980,
    margin: "0 auto",
    borderRadius: 18,
    padding: "18px 16px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(0,0,0,0.55)",
    boxShadow: "0 22px 70px rgba(0,0,0,0.60)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  };

  const h1 = { margin: 0, fontSize: 28, fontWeight: 900, letterSpacing: 0.2 };
  const h2 = { marginTop: 18, fontSize: 16, fontWeight: 900 };
  const p = { marginTop: 10, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 };

  return (
    <div style={card}>
      <h1 style={h1}>Community Guidelines</h1>
      <div style={{ marginTop: 6, color: "rgba(255,255,255,0.70)", fontSize: 13 }}>
        Last updated: January 1, 2026
      </div>

      <p style={p}>
        GAStreaming is a community space. Keep it fun, respectful, and safe.
      </p>

      <div style={h2}>Be respectful</div>
      <ul style={{ marginTop: 8, paddingLeft: 18, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 }}>
        <li>No hate speech, harassment, or targeted insults</li>
        <li>No threats, intimidation, or encouraging harm</li>
        <li>No doxxing or sharing private information</li>
      </ul>

      <div style={h2}>No spam or scams</div>
      <ul style={{ marginTop: 8, paddingLeft: 18, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 }}>
        <li>No spam links, self‑promo floods, or repeated copy/paste</li>
        <li>No impersonation, phishing, or fraud</li>
      </ul>

      <div style={h2}>Keep content legal</div>
      <p style={p}>
        Do not post content that you don’t have the right to share or that violates applicable laws.
      </p>

      <div style={h2}>Enforcement</div>
      <p style={p}>
        We may remove content and suspend accounts for violations. Serious violations can result in permanent
        bans.
      </p>
    </div>
  );
}
